module.exports = function (svg) {
  $(svg).find('animate').remove();
  return svg;
};
